/* Milenium motion + small enhancements. No dependencies. Nothing is hidden unless this file runs. */
(function () {
  var d = document, h = d.documentElement, w = window;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = w.Shopify && w.Shopify.designMode;
  function each(sel, fn, root) { Array.prototype.forEach.call((root || d).querySelectorAll(sel), fn); }

  function stagger(root) {
    each('[data-mm-stagger]', function (g) {
      Array.prototype.forEach.call(g.children, function (c, i) {
        if (!c.hasAttribute('data-mm-reveal')) c.setAttribute('data-mm-reveal', g.getAttribute('data-mm-stagger') || '');
        if (!c.style.getPropertyValue('--mm-i')) c.style.setProperty('--mm-i', i);
      });
    }, root);
  }
  function count(el) {
    var end = parseInt(el.getAttribute('data-mm-count'), 10), from = parseInt(el.getAttribute('data-mm-from') || (end - 20), 10);
    if (reduce || isNaN(end)) return;
    var t0 = null, dur = 1200;
    function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); p = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(from + (end - from) * p); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var io = null;
  function show(el) { el.classList.add('is-in'); setTimeout(function () { el.classList.add('mm-done'); }, 1000); }
  function reveal(root) {
    stagger(root);
    var els = (root || d).querySelectorAll('[data-mm-reveal]:not(.is-in), [data-mm-count]:not(.is-counted)');
    if (reduce || design || !('IntersectionObserver' in w)) { Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in', 'mm-done'); }); return; }
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target; show(el);
        if (el.hasAttribute('data-mm-count') && !el.classList.contains('is-counted')) { el.classList.add('is-counted'); count(el); }
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    var vh = w.innerHeight, first = !h.classList.contains('mm-ready');
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (first && r.top < vh * 0.9 && r.bottom > 0 && el.hasAttribute('data-mm-reveal')) show(el);
      io.observe(el);
    });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mm-yt[data-yt]');
    if (!b || b.querySelector('iframe')) return;
    e.preventDefault();
    var f = d.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + b.getAttribute('data-yt') + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = b.getAttribute('aria-label') || 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    f.allowFullscreen = true;
    b.appendChild(f);
  });

  function injectMenuCta() {
    var tpl = d.getElementById('mm-menu-cta-tpl'), box = d.querySelector('.menu-drawer__navigation-container');
    if (!tpl || !box || box.querySelector('.mm-menu-cta')) return;
    var nav = box.querySelector('.menu-drawer__navigation');
    if (nav && nav.nextSibling) box.insertBefore(tpl.content.cloneNode(true), nav.nextSibling); else box.appendChild(tpl.content.cloneNode(true));
  }
  function injectHeaderCta() {
    var tpl = d.getElementById('mm-hcta-tpl'), icons = d.querySelector('.header__icons');
    if (!tpl || !icons || icons.querySelector('.mm-hcta')) return;
    icons.insertBefore(tpl.content.cloneNode(true), icons.firstChild);
  }
  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
  function shipBar(total) {
    var cfg = d.getElementById('mm-cart-trust-tpl'); if (!cfg) return '';
    var th = parseFloat(cfg.getAttribute('data-threshold')) * 100; if (!th) return '';
    var left = th - total, pct = Math.max(0, Math.min(1, total / th));
    var msg = left > 0 ? 'You’re <b>' + money(left) + '</b> away from free NSW delivery' : '<b>Free NSW delivery</b> unlocked';
    return '<div class="mm-ship">' + msg + '<div class="mm-ship__bar"><i style="transform:scaleX(' + pct.toFixed(3) + ')"></i></div></div>';
  }
  var cartTotal = null;
  function injectCartTrust() {
    var tpl = d.getElementById('mm-cart-trust-tpl'); if (!tpl) return;
    each('.cart-drawer .drawer__footer, .cart__footer .cart__blocks', function (box) {
      if (!box.querySelector('.mm-cart-trust')) box.appendChild(tpl.content.cloneNode(true));
      var old = box.querySelector('.mm-ship');
      if (cartTotal !== null && cartTotal > 0) {
        var html = shipBar(cartTotal);
        if (old) old.outerHTML = html; else box.insertAdjacentHTML('afterbegin', html);
      } else if (old) old.remove();
    });
  }
  function refreshCart() {
    if (!w.fetch) return;
    fetch((w.Shopify && w.Shopify.routes ? w.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price; injectCartTrust(); }).catch(function () {});
  }

  function onScroll(fn) { var t = false; w.addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(function () { fn(); t = false; }); } }, { passive: true }); fn(); }
  function progress() {
    var bar = d.querySelector('[data-mm-progress]'); if (!bar) return;
    var tgt = d.querySelector(bar.getAttribute('data-target')) || d.body, i = bar.querySelector('i');
    onScroll(function () { var r = tgt.getBoundingClientRect(), tot = r.height - w.innerHeight; var p = tot > 0 ? Math.min(1, Math.max(0, -r.top / tot)) : 1; i.style.transform = 'scaleX(' + p.toFixed(4) + ')'; });
  }
  function parallax() {
    if (reduce || w.innerWidth < 990) return;
    var els = d.querySelectorAll('[data-mm-parallax]'); if (!els.length) return;
    onScroll(function () { Array.prototype.forEach.call(els, function (el) { var r = el.parentNode.getBoundingClientRect(); var k = parseFloat(el.getAttribute('data-mm-parallax')) || 0.05; el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - w.innerHeight / 2) * -k).toFixed(1) + 'px,0)'; }); });
  }
  function sticky() {
    var bar = d.querySelector('[data-mm-sticky]'); if (!bar) return;
    var hides = d.querySelectorAll('[data-mm-sticky-hide]');
    onScroll(function () {
      var on = w.scrollY > 480, vh = w.innerHeight;
      Array.prototype.forEach.call(hides, function (s) { var r = s.getBoundingClientRect(); if (r.top < vh * 0.8 && r.bottom > vh * 0.2) on = false; });
      if (w.innerHeight + w.scrollY >= d.body.scrollHeight - 200) on = false;
      bar.classList.toggle('is-on', on);
    });
  }

  function init() {
    reveal();
    h.classList.add('mm-ready');
    injectHeaderCta(); injectMenuCta(); refreshCart(); progress(); parallax(); sticky();
    var cd = d.querySelector('cart-drawer');
    var rt = null;
    if (cd && w.MutationObserver) new MutationObserver(function () { if (!cd.querySelector('.mm-cart-trust')) { injectCartTrust(); clearTimeout(rt); rt = setTimeout(refreshCart, 150); } }).observe(cd, { childList: true, subtree: true });
    /* PUB_SUB_EVENTS is a top-level const in Dawn, so it is not a window property. */
    var evs = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : w.PUB_SUB_EVENTS;
    if (typeof w.subscribe === 'function' && evs) w.subscribe(evs.cartUpdate, function () {
      refreshCart();
      var b = d.querySelector('.cart-count-bubble'); if (b && !reduce) { b.classList.remove('mm-pulse'); void b.offsetWidth; b.classList.add('mm-pulse'); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function (e) { reveal(e.target); injectHeaderCta(); injectMenuCta(); });
})();